/* Smart cart drawer actions (yourTMJ). Loaded by snippets/cart-drawer.liquid.
   Every button carries data-sc-updates: a JSON object of { variantId: quantity } that the cart
   must end up with. One POST to /cart/update.js applies it and the whole drawer re-renders from
   Liquid (sections=cart-drawer,cart-icon-bubble), so the prices shown are always checkout's own.
   The drawer also "normalizes" what other code added (Pen + Release Oil lines -> The Ultimate
   Bundle product, 2 Pens -> Pen + extra-Pen pack, ...) via a data-sc-normalize JSON the snippet emits. */
(function () {
  if (window.__smartCartBound) return;
  window.__smartCartBound = true;

  var lastNormalize = '';

  function onCartPage() { return /^\/cart(\/|$|\?)/.test(window.location.pathname); }
  function drawerEl() { return document.querySelector('cart-drawer'); }

  function rerender(data) {
    var d = drawerEl();
    if (!d || !data || !data.sections) return false;
    try { if (typeof d.init === 'function') d.init(); } catch (e) {}
    if (typeof d.renderContents !== 'function') return false;
    try { d.renderContents({ id: null, sections: data.sections }, true); } catch (e) { console.error('[smart-cart] render failed', e); return false; }
    // Ignite's empty-state layout and focus trap key off this class; the smart drawer renders its own empty state
    d.classList.remove('is-empty');
    setTimeout(function () { d.classList.remove('is-empty'); normalize(); }, 0);
    return true;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      // the storefront's bot check (or a rate limit) answers cart calls with an HTML page instead of the cart:
      // flag it. (A normal answer comes as text/javascript, so only HTML, 403/429 or unreadable bodies count.)
      var type = (res.headers && res.headers.get('content-type')) || '';
      function refused(why) { var b = new Error('cart call refused: ' + why); b.blocked = true; return b; }
      if (res.status === 403 || res.status === 429 || type.indexOf('text/html') > -1) throw refused(res.status + ' ' + type);
      return res.json()
        .catch(function () { throw refused('not JSON, ' + res.status); })
        .then(function (j) { if (!res.ok || j.status) { throw new Error((j && (j.description || j.message)) || ('cart update failed: ' + res.status)); } return j; });
    });
  }

  // PREVIEW 2026-10-22 (option C): keep the Release Oil row at the same spot on screen across the redraw
  function oilRowTop() {
    var d = drawerEl();
    var r = d && d.querySelector('.oc-row');
    return r ? r.getBoundingClientRect().top : null;
  }
  function keepOilRow(oldTop) {
    if (oldTop == null) return;
    var d = drawerEl();
    var body = d && d.querySelector('.sc-body');
    var r = d && d.querySelector('.oc-row');
    if (!body || !r) return;
    body.scrollTop += r.getBoundingClientRect().top - oldTop;
  }

  // after the bottle goes in, the sizes under the row must be on screen (short phones put them under the footer)
  function showChips() {
    var d = drawerEl();
    var body = d && d.querySelector('.sc-body');
    var c = d && d.querySelector('.oc-chips');
    if (!body || !c) return;
    var over = c.getBoundingClientRect().bottom + 8 - body.getBoundingClientRect().bottom;
    if (over > 0) body.scrollTop += over;
  }

  // after a tap on the row or a chip: give focus back (the redraw destroys the focused button) and announce the change
  function afterOil(key, hadFocus) {
    if (!key) return;
    var d = drawerEl();
    if (!d) return;
    var el = d.querySelector('[data-oc-key="' + key + '"]') || d.querySelector('.oc-row');
    if (hadFocus && el) {
      var inner = d.querySelector('.drawer__inner');
      if (typeof trapFocus === 'function' && inner) { try { trapFocus(inner, el); } catch (e) { el.focus(); } }
      else { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }
    var row = d.querySelector('.oc-row');
    var live = d.querySelector('#CartDrawer-LiveRegionText');
    if (row && live) {
      var say = row.getAttribute('data-oc-say') || '';
      setTimeout(function () { live.textContent = say; }, 150);
    }
  }

  function apply(updates, btn) {
    var anchor = btn && btn.matches && btn.matches('.oc-row, .oc-chip, .oc-hit') ? oilRowTop() : null;
    var ocKey = btn && btn.getAttribute ? btn.getAttribute('data-oc-key') : null;
    var hadFocus = !!(btn && document.activeElement === btn);
    var d = drawerEl();
    if (d) d.classList.add('sc-busy');
    if (btn) btn.classList.add('is-loading');
    var payload = { updates: updates };
    if (!onCartPage()) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
    return post('/cart/update.js', payload)
      .then(function (data) {
        if (onCartPage()) { window.location.reload(); return; }
        if (!rerender(data)) { window.location.assign('/cart'); return; }
        if (anchor != null) {
          keepOilRow(anchor); showChips();
          if (window.requestAnimationFrame) requestAnimationFrame(function () { keepOilRow(anchor); showChips(); });
          afterOil(ocKey, hadFocus);
        }
      })
      .catch(function (err) {
        console.error('[smart-cart]', err);
        var e = document.querySelector('.sc-err');
        if (err && err.blocked) {
          // every further tap would fail the same way until a page load: reload, so the shopper sees the store's
          // check (or simply the page again) with the cart as it really is
          if (e) e.textContent = 'Refreshing your cart…';
          setTimeout(function () { window.location.reload(); }, 600);
          return;
        }
        if (e) e.textContent = 'Sorry, that did not go through. Please try again.';
      })
      .finally(function () {
        var d2 = drawerEl();
        if (d2) d2.classList.remove('sc-busy');
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function readUpdates(el) {
    var raw = el.getAttribute('data-sc-updates');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { console.error('[smart-cart] bad updates', raw); return null; }
  }

  // the snippet emits <script type="application/json" data-sc-normalize> when the cart's lines are not
  // in the canonical shape; apply it once per distinct payload (never loops: a canonical cart emits none)
  function normalize() {
    var d = drawerEl();
    if (!d || onCartPage()) return;
    var s = d.querySelector('script[data-sc-normalize]');
    if (!s) return;
    var raw = (s.textContent || '').trim();
    if (!raw || raw === lastNormalize) return;
    lastNormalize = raw;
    var updates;
    try { updates = JSON.parse(raw); } catch (e) { return; }
    apply(updates, null);
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-sc-pick]');
    if (pick) {
      e.preventDefault();
      var card = pick.closest('.sc-card');
      if (!card) return;
      card.querySelectorAll('[data-sc-pick]').forEach(function (b) { b.classList.toggle('is-on', b === pick); });
      var add = card.querySelector('.sc-add[data-sc-follows]');
      if (add) {
        add.setAttribute('data-sc-updates', pick.getAttribute('data-sc-updates') || '');
        add.innerHTML = pick.getAttribute('data-sc-label') || add.innerHTML;
      }
      return;
    }
    // A/B test 'oilrow', variant B (html[data-ab-oilrow="b"], set by ab-enforcer): the picture and the title of the empty
    // Release Oil row add the oil like the rest of the row, instead of leaving the drawer for the oil page (control keeps
    // the links). Dormant without the attribute. Also catches Enter on the title link (a click event).
    var abRowLink = document.documentElement.getAttribute('data-ab-oilrow') === 'b'
      ? e.target.closest('[data-sc-rowadd] .oc-img, [data-sc-rowadd] .oc-t-link') : null;
    if (abRowLink) {
      e.preventDefault();
      var abAdd = abRowLink.closest('[data-sc-rowadd]').querySelector('.oc-add-txt');
      if (abAdd) abAdd.click();
      return;
    }
    // the Release Oil row with no oil in it (take 2): a tap on the row's own padding or gaps counts as the add
    var rowAdd = e.target.closest('[data-sc-rowadd]');
    if (rowAdd && !e.target.closest('a, button')) {
      var addBtn = rowAdd.querySelector('.oc-add-txt');
      if (addBtn) { e.preventDefault(); addBtn.click(); }
      return;
    }
    var btn = e.target.closest('[data-sc-updates]');
    if (!btn || btn.hasAttribute('data-sc-pick')) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    if (btn.classList.contains('oc-chip') && btn.getAttribute('aria-pressed') === 'true') return; // already that size
    var updates = readUpdates(btn);
    if (!updates) return;
    apply(updates, btn);
  });

  // other code (the buy box, the product form) added to the cart: normalize whenever the drawer opens or re-renders.
  // (Ignite publishes cartOpen on transitionend, which does not fire under reduced motion, so hook the methods too.)
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartOpen, function () { setTimeout(normalize, 50); });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (ev && ev.source === 'smart-cart') return;
      setTimeout(normalize, 300);
    });
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var proto = customElements.get('cart-drawer').prototype;
      if (proto.__smartCartHooked) return;
      proto.__smartCartHooked = true;
      var open = proto.open, render = proto.renderContents;
      proto.open = function () { var r = open.apply(this, arguments); setTimeout(normalize, 150); setTimeout(normalize, 1200); return r; };
      proto.renderContents = function () { var r = render.apply(this, arguments); setTimeout(normalize, 60); return r; };
    }).catch(function () {});
  }
  // the drawer is as tall as the VISIBLE viewport (browser chrome, docks and the iOS toolbars shrink it), never 100vh
  function sizeToViewport() {
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    if (h) document.documentElement.style.setProperty('--sc-vvh', Math.round(h) + 'px');
  }
  sizeToViewport();
  window.addEventListener('resize', sizeToViewport);
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', sizeToViewport); window.visualViewport.addEventListener('scroll', sizeToViewport); }

  // belt and braces: any re-render of the drawer (Ignite's own paths included) is followed by a normalize pass
  function watch() {
    var d = drawerEl();
    if (!d || d.__scObserved || typeof MutationObserver !== 'function') return;
    d.__scObserved = true;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(normalize, 120); }).observe(d, { childList: true, subtree: true });
  }
  watch();
  setTimeout(normalize, 0);
  setTimeout(normalize, 900);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); setTimeout(normalize, 400); });
})();
